import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-price-breakdown',
  templateUrl: './price-breakdown.component.html',
  styleUrls: ['./price-breakdown.component.scss']
})
export class PriceBreakdownComponent implements OnInit {

  @Input()
  price;

  @Input()
  timeslot;

  @Input()
  amendType;

  @Input()
  bookingABC;

  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  @Input()
  languageCode;

  @Input()
  premiumSurcharge;

  public pricingBreakdown = null;

  constructor() { }

  ngOnInit() {
    console.log(this.languageCode)
   }

}
